<template>
	<div class="index h-full ">
		<van-nav-bar
			left-text="返回"
			title="医生列表"
			left-arrow
			@click-left="back"
		/>
		<div class="w-full h-full doctor-list">
			<div class="doctor-list-item" v-for="(item,index) in doctorList" :key="index">
				<div class="w-full layout-left-top">
					<div class="doctor-list-item-cover layout-center-v">
						<img class="w-full h-full" style="height: var(--base-px-48);border-radius: var(--base-px-48)" :src="item.cover" alt=""/>
					</div>
					<div class="doctor-list-item-info">
						<div class="w-full layout-left-center">
							<div style="font-size: var(--base-px-20);font-weight: 500;line-height: normal;">{{ item.doctor_name }}</div>
							<div style="margin-left: var(--base-px-12);font-size: var(--base-px-14);font-weight: normal;">{{
									item.title_name
								}}
							</div>
						</div>
						<div class="w-full layout-left-center" style="margin-top: var(--base-px-8)">
							<div style="font-size: var(--base-px-14);">{{ item.hospital_name }}</div>
							<div style="font-size: var(--base-px-14);font-weight: 350;margin-left: var(--base-px-12)">{{
									item.departmrnt_name
								}}
							</div>
						</div>
						<div class="w-full layout-left-center" v-if="item.is_prescription===1" style="margin-top: var(--base-px-8)">
							<div class="layout-center"
							     style="border-radius: var(--base-px-8);background: #E8F3F1;color: #199A8E;font-size: var(--base-px-11);padding: var(--base-px-4) var(--base-px-12)">
								可开处方
							</div>
						</div>
						<div class="w-full layout-left-top" style="font-size: var(--base-px-12);margin-top: var(--base-px-8)">
							擅长：{{ item.be_good_at }}
						</div>
						<div class="w-full layout-left-center" style="font-size: var(--base-px-12);margin-top: var(--base-px-8)">
							<div class="doctor-list-item-l layout-left-center" style="width: 30%">接诊量&nbsp;&nbsp;
								<span style="color: #199A8E">{{ item.month_reply }}</span></div>
							<div class="doctor-list-item-l layout-center"
							     style="width:40%;border-left: var(--base-px-1) solid #cccccc;border-right: var(--base-px-1) solid #cccccc">
								平均响应&nbsp;&nbsp;
								<span style="color: #199A8E">{{ item.response_time }}</span>
							</div>
							<div class="doctor-list-item-l layout-right-center" style="width: 30%">好评率&nbsp;&nbsp;
								<span style="color: #199A8E">100%</span></div>
						</div>
					</div>
				</div>
				<div class="w-full layout-side" style="margin-top: var(--base-px-12)">
					<div class="layout-center button" style="width: 30%;">图文¥{{ item.graphic_price }}</div>
					<div class="layout-center button" style="width: 30%;">视频¥{{ item.video_price }}</div>
					<div class="layout-center button" style="width: 30%;background: #30ADA2;color: #ffffff">分享</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {doctorList, doctorShare} from '../../api/doctor'

export default defineComponent({
	name: "index",
	data() {
		return {
			doctorList: [],
			doctorShareList: [],
		}
	},
	created() {
		doctorList().then(res => {
			console.log(res.data)
			this.doctorList = res.data
		})
	},
	methods: {
		back() {
			this.$router.back()
		},
	}
})
</script>
<style scoped lang="less">
.index {
	font-size: var(--base-px-14);
	min-height: 100%;
	background-color: #f2f3f7;
	width: 100%;

	.doctor-list {
		padding: var(--base-px-12);

		&-item {
			border-radius: var(--base-px-12);
			box-sizing: border-box;
			border: var(--base-px-2) solid #E8F3F1;
			background: #FFFFFF;
			padding: var(--base-px-12);
			margin-bottom: var(--base-px-12);
			color: #1A1A1A;

			.button {
				padding: var(--base-px-6) 0;
				border-radius: var(--base-px-20);
				font-size: var(--base-px-12);
				border: var(--base-px-1) solid #199A8E;
				color: #199A8E;
			}

			&-l {
				width: 33.33%;
			}

			&-cover {
				width: var(--base-px-48);
			}

			&-info {
				width: calc(100% - var(--base-px-48));
				padding-left: var(--base-px-12);
			}
		}
	}
}
</style>